import { useApplicationContext } from "components/Application";
import { capitalize } from "lodash";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import tw from "twin.macro";

export const List: React.FC<{}> = () => {
  const {
    siteEnvironment: { appEndpointStore },
    session,
  } = useApplicationContext();
  const { user, currentUser } = session;
  const { brands } = currentUser;

  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  let visibleBrands = brands;
  if (user?.role === "SALESPERSON" && user?.id !== currentUser?.id) {
    visibleBrands = [];
    const { userBrands } = currentUser;
    brands?.forEach((brand: any) => {
      userBrands?.forEach((userBrand: any) => {
        if (userBrand?.brand?.id === brand?.id && userBrand?.salesperson?.id === user?.id) visibleBrands?.push(brand);
      });
    });
  }

  return (
    <Fragment>
      <div tw="flex lg:space-x-1 h-full">
        {visibleBrands.map((brand: any, index: number) => {
          const even = index % 2 === 0;

          return (
            <Fragment key={brand.id}>
              <div
                key={brand.code}
                css={[
                  tw`lg:flex hidden w-full lg:bg-cover bg-contain bg-no-repeat bg-center bg-top items-end lg:p-8 p-2 justify-start`,
                  even && tw`justify-end`,
                ]}
                style={{
                  backgroundImage: `url(${appEndpointStore}${
                    visibleBrands.length > 1 ? brand.coverVertical : brand.coverHorizontal
                  })`,
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div tw="lg:flex lg:w-auto lg:mb-0 lg:flex-col lg:space-y-4 lg:gap-0 lg:mx-0 grid grid-cols-1 gap-4 mx-4 w-full mb-32">
                  {brand.seasons.map(
                    (season: any) =>
                      season.isEnabled && (
                        <Link
                          key={season.code}
                          to={`/b/${brand.id}/s/${season.id}`}
                          tw="block lg:bg-white bg-gray-900 text-center border-default py-2 px-8 lg:text-gray-900 text-white outline-none hover:(lg:bg-white lg:text-gray-900 bg-white text-gray-900)"
                        >
                          {`${season[`name${languageSuffix}`]} ${season[`kind${languageSuffix}`]}`.toUpperCase()}
                        </Link>
                      ),
                  )}
                  <Link
                    key={`${brand.code}-press-kit`}
                    to={`/b/${brand.id}/pk`}
                    tw="block lg:bg-white bg-gray-900 text-center border-default py-2 px-8 lg:text-gray-900 text-white outline-none hover:(lg:bg-white lg:text-gray-900 bg-white text-gray-900)"
                  >
                    PRESS KIT
                  </Link>
                </div>
              </div>
              <div key={`${brand.code}-responsive-`} css={[tw`lg:hidden flex flex-col w-full items-end p-0 ml-0`]}>
                <div css={[tw`p-0 ml-1 mr-0`, even && tw`p-0 mr-1 ml-0`]}>
                  <img
                    alt={`${brand.code}-responsive-img`}
                    src={`${appEndpointStore}${visibleBrands.length > 1 ? brand.coverVertical : brand.coverHorizontal})`}
                  />
                </div>
                <div tw="grid grid-cols-1 gap-4 w-full md:p-8 p-4">
                  {brand.seasons.map(
                    (season: any) =>
                      season.isEnabled && (
                        <Link
                          key={`${brand.code}-${season.code}-responsive`}
                          to={`/b/${brand.id}/s/${season.id}`}
                          tw="block lg:bg-white bg-gray-900 text-center border-default py-2 px-8 lg:text-gray-900 text-white outline-none hover:(lg:bg-white lg:text-gray-900 bg-white text-gray-900)"
                        >
                          {`${season[`name${languageSuffix}`]} ${season[`kind${languageSuffix}`]}`.toUpperCase()}
                        </Link>
                      ),
                  )}
                  <Link
                    key={`${brand.code}-pk-responsive`}
                    to={`/b/${brand.id}/pk`}
                    tw="block lg:bg-white bg-gray-900 text-center border-default py-2 px-8 lg:text-gray-900 text-white outline-none hover:(lg:bg-white lg:text-gray-900 bg-white text-gray-900)"
                  >
                    PRESS KIT
                  </Link>
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
    </Fragment>
  );
};
